import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute.tsx';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper.tsx';

const CopySutraDetail = lazy(() => import('@/pages/copy-sutra/Detail'));
export const copySutraRoutes: RouteObject = {
  path: 'copy-sutra/',
  children: [
    {
      path: 'detail/:uuid',
      element: (
        <ProtectedRoute pageKey="page:copy-sutra:detail">
          <SuspenseWrapper>
            <CopySutraDetail />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
  ],
};
